import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Componente auxiliar para hacer scroll to top en cada ruteo  */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
